/* eslint-disable quote-props */
const alert = {
  'alert.401': 'Nieautoryzowany dostęp',
  'alert.404': 'Nieprawidłowy adres URL',
  'alert.500': 'Wewnętrzny błąd serwera',
  'alert.dataFailedToRetrieve': 'Nie udało się pobrać danych',
  'alert.refreshPage': 'odśwież stronę',
}

const channelsFloorspaceModal = {
  'channelsFloorspaceModal.company': 'Spółka',
  'channelsFloorspaceModal.floorSpacePerStoreCurrent': 'Śr. pow. sklepu',
  // eslint-disable-next-line sonarjs/no-duplicate-string
  'channelsFloorspaceModal.revenuePerM2Current': 'Sprzedaż/m²',
  'channelsFloorspaceModal.storesCurrent': 'Ilość sklepów',
  'channelsFloorspaceModal.surface': 'Powierzchnia',
}

const channelsTabs = {
  'channelsTabs.channels': 'Szyldy',
  'channelsTabs.countries': 'Kraje',
  'channelsTabs.owners': 'Spółki',
  'channelsTabs.saleTypes': 'Typy sprzedaży',
}

const clubCardModal = {
  'clubCardModal.application': 'Aplikacja',
  'clubCardModal.company': 'Spółka',
  'clubCardModal.newClubCards': 'Nowe karty klub.',
  'clubCardModal.no': 'Nr',
  'clubCardModal.revenueClubCCC': 'Sprzedaż Klub CCC',
  'clubCardModal.shareClubCard': 'Udział kart klubowych',
}

const config = {
  language: 'pl',
}

const countries = {
  'countries.apparel': 'Apparel',
  'countries.austria': 'Austria',
  'countries.bulgaria': 'Bułgaria',
  'countries.croatia': 'Chorwacja',
  'countries.czechrepublic': 'Republika Czeska',
  'countries.deezee': 'Deezee',
  'countries.EOB2': 'EOB2',
  'countries.eobuwie': 'eobuwie.pl',
  'countries.estonia': 'Estonia',
  'countries.germany': 'Niemcy',
  'countries.ginorossi': 'Gino-Rossi',
  'countries.halfprice': 'Halfprice',
  'countries.hungary': 'Węgry',
  'countries.latvia': 'Łotwa',
  'countries.lithuania': 'Litwa',
  'countries.modivo': 'Modivo',
  'countries.moldova': 'Mołdawia',
  'countries.none': '-',
  'countries.outlet': 'CCC Outlet',
  'countries.poland': 'Polska',
  'countries.romania': 'Rumunia',
  'countries.russia': 'Rosja',
  'countries.serbia': 'Serbia',
  'countries.slovakia': 'Słowacja',
  'countries.slovenia': 'Słowenia',
  'countries.switzerland': 'Szwajcaria',
  'countries.turkey': 'Turcja',
  'countries.ukraine': 'Ukraina',
  'countries.vogele': 'Vogele',
}

const menu = {
  'menu.behalfOfUserName': 'W imieniu {{user}}',
  'menu.date.chooseDate': 'Wybierz datę',
  'menu.date.dayBeforeYesterday': 'Przedwczoraj',
  'menu.date.today': 'Dzisiaj',
  'menu.date.todayWarning': 'brak danych',
  'menu.date.yesterday': 'Wczoraj',
  'menu.date': '(data sprzedaży: {{date}})',
  'menu.help': 'Pomoc',
  'menu.info': 'O Aplikacji',
  'menu.language.english': 'Angielski',
  'menu.language.polish': 'Polski',
  'menu.language.title': 'Język',
  'menu.localCurrency.no': 'Waluta grupy (PLN)',
  'menu.localCurrency.title': 'Wybierz walutę',
  'menu.localCurrency.yes': 'Waluta lokalna',
  'menu.logout': 'Wyloguj się',
  'menu.myProfile': 'Mój profil',
  'menu.reportBug': 'Zgłoś sugestię',
  'menu.revenue': 'SPRZEDAŻ',
  'menu.title': 'Grupa CCC',
  'menu.traffic': 'TRAFFIC',
}

const myResults = {
  'myResults.avgCart': 'Śr. koszyk',
  'myResults.avgCartCCC': 'Śr. koszyk CCC ',
  'myResults.avgConversion': 'Śr. konwersja',
  'myResults.avgPerStore': 'Śr. / sklep',
  'myResults.avgRevenuePerStore': 'Śr. sprzedaż na sklep:',
  'myResults.ranking': 'Ranking',
  'myResults.revenue': 'Utarg',
  'myResults.revenueM2': 'Sprzedaż/m²',
  'myResults.sales': 'sprzedaży',
  'myResults.title': 'MOJE WYNIKI vs ŚREDNIA REGIONU',
}

const date = {
  'date.apply': 'Wybierz',
  'date.cancel': 'Anuluj',
  'date.closedPeriod.halfyear': 'półrocze',
  'date.closedPeriod.month': 'miesiąc',
  'date.closedPeriod.quarter': 'kwartał',
  'date.closedPeriod.week': 'tydzień',
  'date.closedPeriod.week2': '2 tygodnie',
  'date.closedPeriods.range.halfyear': 'półrocze',
  'date.closedPeriods.range.month': 'miesiące',
  'date.closedPeriods.range.quarter': 'kwartały',
  'date.closedPeriods.range.week': 'tygodnie',
  'date.closedPeriods.range.week2': '2 tygodnie',
  'date.comparisonDate': 'Data do porównania',
  'date.dataRange': 'Zakres danych',
  'date.datePicker': 'Wybór dat',
  'date.dayMonthFormat': 'ddd DD.MM',
  'date.from': 'Od',
  'date.from.day': 'Data do porównania',
  'date.from.month': 'Od początku miesiąca',
  'date.from.month2': 'Od początku miesiąca vs L2Y',
  'date.from.month2e1': 'Od początku miesiąca vs LY dla ecom i L2Y dla B&M',
  'date.from.quarter': 'Od początku kwartału',
  'date.from.quarter2': 'Od początku kwartału vs L2Y',
  'date.from.quarter2e1': 'Od początku kwartału vs LY dla ecom i L2Y dla B&M',
  'date.from.year': 'Od początku roku',
  'date.from.year2': 'Od początku roku vs L2Y',
  'date.from.year2e1': 'Od początku roku vs LY dla ecom i L2Y dla B&M',
  'date.fromDate.halfyear': 'od początku półrocza (HTD)',
  'date.fromDate.month': 'od początku miesiąca (MTD)',
  'date.fromDate.quarter': 'od początku kwartału (QTD)',
  'date.fromDate.week': 'od początku tygodnia (WTD)',
  'date.fromDate.year': 'od początku roku (YTD)',
  'date.perClosedPeriods': 'dla zamkniętych okresów',
  'date.perDay': 'dla dnia',
  'date.perEndDate': 'do daty',
  'date.perEndDateDescription': 'Aplikacja pokaże wyniki skumulowane od początku wybranego okresu, tj. ',
  'date.pickedDate': 'Wybrany dzień (TD)',
  'date.salesDate': 'Data Sprzedaży',
  'date.selectComparisonDate': 'Wybierz datę do porównania',
  'date.selectedEndDate': 'Wybrana data końcowa',
  'date.selectSalesDate': 'Wybierz datę sprzedaży',
  'date.showResultPer': 'Aplikacja pokaże wyniki za {{period}}',
  'date.to': 'do',
  'date.typeAnalysis': 'Rodzaj analizy:',
  'date.year': 'Rok',
}

const common = {
  'common.date': 'Data',
  'common.noInternetConnection': 'Brak połączenia z Internetem',
}

const rankings = {
  'rankings.best20Shops': 'Najlepsze 20 sklepów',
  'rankings.clubCardsCurrent': 'Nowe karty',
  'rankings.clubShareCurrent': 'Udział sprzedaży',
  'rankings.companies': 'Spółki',
  'rankings.companiesByChannels': 'Spółki według kanałów',
  'rankings.companiesClubCard': 'Spółki z klubowiczami',
  'rankings.companiesEcommerce': 'Spółki e-commerce',
  'rankings.companiesEcommerceOrders': 'Spółki e-commerce - zamówienia',
  'rankings.companiesStationary': 'Spółki stacjonarne',
  'rankings.company': 'Spółka',
  'rankings.companyMulti': 'spółki',
  'rankings.companyMulti2': 'spółek',
  'rankings.companySingle': 'spółkę',
  'rankings.comparison': 'Porównanie',
  'rankings.confirm': 'ZATWIERDŹ',
  'rankings.conversionCurrent': 'Średnia konwersja',
  'rankings.dailyRange': 'Ujęcie dzienne',
  'rankings.district': 'Dystrykci',
  'rankings.emptyDistrictManager': '(brak)',
  'rankings.fetchError': 'Nie możemy pobrać danych, sprawdź swoje połączenie internetowe i spróbuj odświeżyć stronę',
  'rankings.found': 'Wybrano {{count}} {{stores}}',
  'rankings.hoursRevenue': 'Godziny przychodów',
  'rankings.indicator': 'Wskaźnik:',
  'rankings.modalFilterCountryTitle': 'Filtruj ranking',
  'rankings.ordersPerDay': 'Zamówienia per dzień',
  'rankings.pos': 'Poz',
  'rankings.revenueChange': 'Przyrost vs LY %',
  'rankings.revenueClubCurrent': 'Sprzedaż klubowa [zł]',
  'rankings.revenueClubCurrentLabel': 'Sprzedaż klubowa',
  'rankings.revenueCurrent': 'Utarg',
  'rankings.revenuePerDay': 'Utarg per dzień',
  'rankings.revenuePerM2Current': 'Sprzedaż/m² [zł]',
  'rankings.revenuePerM2CurrentLabel': 'Sprzedaż/m²',
  'rankings.revenuePerStoreCurrent': 'Śr. utarg',
  'rankings.revenuePerStoreCurrentLabel': 'Średnia na ilość sklepów',
  'rankings.rks': 'RKS',
  'rankings.search': 'Wyszukaj...',
  'rankings.shareCurrent': 'Udział w sprzedaży %',
  'rankings.shop': 'Sklep',
  'rankings.storesEcommerceOrders': 'Witryny e-commerce - zamówienia',
  'rankings.storesOpenWithin12Months': 'Sklepy otwarte w ciagu 12 miesięcy',
  'rankings.storesOpenWithin30Days': 'Sklepy otwarte w ciagu 30 dni',
  'rankings.storesStationary': 'Sklepy stacjonarne',
  'rankings.title': 'Rankingi',
  'rankings.trafficCurrent': 'Traffic',
  'rankings.trafficPerStoreCurrent': 'Średni traffic na sklep',
  'rankings.transactionValueClubCurrent': 'Śr. wartość koszyka klubowego',
  'rankings.transactionValueCurrent': 'Śr. wartość koszyka [zł]',
  'rankings.transactionValueCurrentLabel': 'Średnia wartość koszyka',
  'rankings.websiteEcommerce': 'Witryny e-commerce',
  'rankings.websites': 'Witryny',
  'rankings.weeklyRange': 'Ujęcie tygodniowe',
  'rankings.worst20Shops': 'Najgorsze 20 sklepów',
}

const ReportBugDialog = {
  'ReportBugDialog.description': 'Opis',
  'ReportBugDialog.report': 'Zgłoś',
  'ReportBugDialog.title': 'Tytuł',
}

const returnsValueDetails = {
  'returnsValueDetails.returns': 'Zwroty',
  'returnsValueDetails.returnsValueShareCurrent': 'Udział',
  'returnsValueDetails.sum': 'Suma',
}

const revenue = {
  'revenue.budget': 'Budżet',
  'revenue.changedCompared': 'zaraportowana zmiana',
  'revenue.cluster': 'Klaster',
  'revenue.contribution': 'Udział',
  'revenue.dataDownloadingIsInProgress': 'Trwa pobieranie danych',
  'revenue.dataSource': 'Źródło danych',
  'revenue.details.clubCard': 'CCC Club',
  'revenue.details.clubCard.averageTransactionValue': 'Średnia wartość transakcji',
  'revenue.details.clubCard.clubCardTransactions': 'Transakcje kartą Klubową',
  'revenue.details.clubCard.newCardsOnGivenDay': 'Nowe karty w danym dniu',
  'revenue.details.clubCard.shareStoreSale': 'Udział w sprzedaży sklepu',
  'revenue.details.esizemeProfileUsage': 'użycia profilu',
  'revenue.details.esizemeScans': 'skany',
  'revenue.details.general': 'Ogólne',
  'revenue.details.lastData': 'Ostatnie dane',
  'revenue.details.ordersByOriginAndSource': 'Zamówienia wg źródła i miejsca realizacji',
  'revenue.details.origin': 'Źródło',
  'revenue.details.replenishment': 'Zatowar.',
  'revenue.details.replenishment.other': 'inne',
  'revenue.details.replenishment.replenishmentLever7Days': 'Poziom zatowarowania 7 dni',
  'revenue.details.replenishment.shoes': 'buty',
  'revenue.details.result': 'Wyniki',
  'revenue.details.result.conversion': 'Konwersja',
  'revenue.details.result.date': 'Dzień',
  'revenue.details.result.dayToDay': 'Dzień do dnia',
  'revenue.details.result.number': 'Ilość',
  'revenue.details.result.qtd': 'QTD',
  'revenue.details.result.sale': 'Sprzedaż',
  'revenue.details.result.saleWithoutReturns': 'Sp. bez zwrotów',
  'revenue.details.result.sharePerStore': 'Średnia / Sklep',
  'revenue.details.result.traffic': 'Traffic',
  'revenue.details.result.weather': 'Pogoda',
  'revenue.details.result.ytd': 'YTD',
  'revenue.details.revenueByOriginAndSource': 'Sprzedaż wg źródła i miejsca realizacji',
  'revenue.details.sale': 'Sprzedaż',
  'revenue.details.stores': 'Sklepy',
  'revenue.details.summary': 'Razem',
  'revenue.details.total': 'Łącznie',
  'revenue.details.traffic': 'Traffic',
  'revenue.details.traffic.average': 'Średnia z 7 dni',
  'revenue.details.traffic.day': 'Dzień',
  'revenue.details.traffic.LY': 'LY',
  'revenue.details.traffic.today': 'Traffic dzisiaj',
  'revenue.details.traffic.vsLY': 'Traffic vs LY',
  'revenue.details.traffic.week': 'Traffic 7 dni',
  'revenue.details.warehouse': 'Magazyn',
  'revenue.ecom.legend': 'Średnia wartość',
  'revenue.express': 'Express',
  'revenue.fair': 'Likwidacja',
  'revenue.floorSpaceDecreased': 'zmniejszenie powierzchni',
  'revenue.floorSpaceIncreased': 'zwiększenie powierzchni',
  'revenue.lifting': 'Lifting',
  'revenue.ly': 'LY',
  'revenue.necom.legend': 'Średnia/sklep',
  'revenue.new': 'Nowy',
  'revenue.noComparableStoresOpen': 'Brak {{type}} sklepów porównywalnych',
  'revenue.noData': 'brak danych',
  'revenue.noOnlineReportingStores': 'Brak {{type}} sklepów internetowych',
  'revenue.noOpenStationaryStores': 'Brak {{type}} sklepów stacjonarnych',
  'revenue.noOpenStoresWithAChangeOfArea': 'Brak {{type}} sklepów ze zmianą powierzchni',
  'revenue.noOpenStoresWithFloorDecrease': 'Brak {{type}} sklepów z zmniejszoną powierzchnią',
  'revenue.noOpenStoresWithFloorIncrease': 'Brak {{type}} sklepów z zwiększoną powierzchnią',
  'revenue.noOrdersToEcom': 'Brak zamówień do sklepów internetowych',
  'revenue.noStores': 'W danym dniu nie powstał żaden sklep i żaden nie zmienił powierzchni w ciągu ostatnich 30 dni',
  'revenue.plan': 'planu',
  'revenue.pp': 'p.p.',
  'revenue.promotion': 'promocja',
  'revenue.revenue': 'Utarg',
  'revenue.salesWithoutReturns': 'Sprzedaż bez zwrotów:',
  'revenue.sisterStores': 'Siostrzane sklepy',
  'revenue.stats.average': 'Średnio',
  'revenue.stats.averageShort': 'Śr:',
  'revenue.stats.avgL4L': 'Śr. L4L',
  'revenue.stats.avgNew': 'Śr. nowe',
  'revenue.stats.avgSurfaceShort': 'Śr. pow.',
  'revenue.stats.avgSurfaceShortCCC': 'Śr. pow. CCC',
  'revenue.stats.comparableDay': 'Dzień porównywalny',
  'revenue.stats.compare': 'Porów.',
  'revenue.stats.completeness': 'Kompletność danych',
  'revenue.stats.completeness.activeClosed': 'Zamknięte wg kalendarza',
  'revenue.stats.completeness.back': 'Powrót',
  'revenue.stats.completeness.closedReporting': 'Raportujące zamknięte',
  'revenue.stats.completeness.company': 'Spółka',
  'revenue.stats.completeness.delayedRtlog': 'Nieraportujące w rtlog',
  'revenue.stats.completeness.delayedStores': 'Nieraportujące otwarte',
  'revenue.stats.completeness.header': 'AKTUALIZACJA DANYCH',
  'revenue.stats.completeness.hour': 'Godzina',
  'revenue.stats.completeness.latestReports': 'Ostatnie raporty',
  'revenue.stats.completeness.noActiveClosed': 'Wszystkie sklepy były otwarte wg kalendarza w ciągu ostatnich dwóch godzin.',
  'revenue.stats.completeness.noActiveClosedAfter16': 'Wszystkie sklepy były otwarte wg kalendarza po godzinie 16.',
  'revenue.stats.completeness.noDelayedStores': 'Wszystkie sklepy raportowały dane w ciągu ostatnich dwóch godzin.',
  'revenue.stats.completeness.noDelayedStoresAfter16': 'Wszystkie sklepy raportowały dane po godzinie 16.',
  'revenue.stats.completeness.noReports': 'Lista spółek, które zgodnie z ustaleniami biznesowymi nie raportują danych do Utargów',
  'revenue.stats.completeness.noZeroReporting': 'Wszystkie sklepy raportowały niezerową sprzedaż po godzinie 16.',
  'revenue.stats.completeness.noZeroReportingAfter16':
    'Wszystkie sklepy raportowały niezerową sprzedaż w ciągu ostatnich dwóch godzin.',
  'revenue.stats.completeness.reason': 'Powód',
  'revenue.stats.completeness.store': 'Sklep',
  'revenue.stats.completeness.storesECom': 'witryn internetowych',
  'revenue.stats.completeness.storesNECom': 'sklepów stacjonarnych',
  'revenue.stats.completeness.storesReportingZero': 'Raportowało zerową sprzedaż w ciągu ostatniej godziny.',
  'revenue.stats.completeness.storesReportingZeroAfter16': 'Raportowało zerową sprzedaż po godzinie 16.',
  'revenue.stats.completeness.storesReportingZeroPerDay': 'Raportowało zerową sprzedaż w wybranym dniu.',
  'revenue.stats.completeness.storesWithoutReports': 'Nie raportowało danych w ciągu ostatniej godziny.',
  'revenue.stats.completeness.storesWithoutReportsAfter16': 'Nie raportowało danych po godzinie 16.',
  'revenue.stats.completeness.storesWithoutReportsPerDay': 'Nie raportowało danych w wybranym dniu.',
  'revenue.stats.completeness.zeroReporting': 'Raportujące zerową sprzedaż',
  'revenue.stats.generalSurface': 'Pow. ogólna',
  'revenue.stats.l4l': 'L4L',
  'revenue.stats.new': 'Nowe',
  'revenue.stats.quantityL4L': 'Il. L4L',
  'revenue.stats.quantityNew': 'Il. nowe',
  'revenue.stats.sale': 'sprzed.',
  'revenue.stats.store': 'Sklep',
  'revenue.stats.stores': 'Sklepy',
  'revenue.stats.storesActive': 'Sklepy czynne',
  'revenue.stats.storesAlt': 'Sklepów',
  'revenue.stats.storesOpen': 'Sklepy otwarte',
  'revenue.stats.surface': 'Pow. handlowa',
  'revenue.stats.together': 'Łącznie',
  'revenue.stats.traffic': 'Traffic',
  'revenue.stats.websitesActive': 'Witryny czynne',
  'revenue.stats.websitesOpen': 'Witryny otwarte',
  'revenue.store': 'sklep',
  'revenue.stores': 'sklepy',
  'revenue.storesAlt': 'sklepów',
  'revenue.summary': 'Podsumowanie',
  'revenue.table.category': 'Kategoria',
  'revenue.table.closeDate': 'Data zamknięcia',
  'revenue.table.concept': 'Koncept',
  'revenue.table.from': 'od',
  'revenue.table.openDate': 'Data otwarcia',
  'revenue.table.openingHours': 'Godziny otwarcia',
  'revenue.table.regionManagerPhone': 'Numer telefonu RKS',
  'revenue.table.renovations': 'Daty remontów',
  'revenue.table.rks': 'RKS',
  'revenue.table.trim': 'Wykończenie',
  'revenue.type.active': 'czynnych',
  'revenue.type.open': 'otwartych',
  'revenue.type.reporting': 'raportujących',
  'revenue.type.selling': 'sprzedających',
  'revenue.website': 'Witryna',
  'revenue.websites': 'Witryny',
}

const tableClubCard = {
  'tableClubCard.avgValue': 'Śr. wartość',
  'tableClubCard.clubRevenue': 'Sprzedaż klubowa',
  'tableClubCard.newCards': 'Nowe karty',
  'tableClubCard.percentRevenue': '% utargu',
}

const tableEsize = {
  'tableEsize.esize': 'esize.me',
  'tableEsize.esizemeShareCurrent': '% z profilu',
}

const tableMargin = {
  'tableMargin.margin': 'Marża',
  'tableMargin.grossProfit': 'Zysk brutto',
}

const tableOrders = {
  'tableOrders.orders': 'Il. zam.',
  'tableOrders.ordersShare': 'Udział ilości',
  'tableOrders.ordersValue': 'War. zam.',
  'tableOrders.ordersValueShare': 'Udział wartości',
  'tableOrders.orderValue': 'Śr. zam.',
}

const tableReplenishment = {
  'tableReplenishment.replenishmentShoes': 'Zatowarowanie obuwie',
  'tableReplenishment.replenishmentOther': 'Zatowarowanie inne',
}

const tableSourceData = {
  'tableSourceData.resa': 'Resa',
  'tableSourceData.traffic': 'Traffic',
  'tableSourceData.expos': 'Szybkie Utargi',
}

const tableTraffic = {
  'tableTraffic.traffic': 'Traffic',
}

const tableWeather = {
  'tableWeather.weather': 'Pogoda',
}

const box = {
  'box.allStores': 'Wszystkie sklepy',
  'box.allWebsites': 'Wszystkie witryny',
  'box.browse': 'Przeglądaj:',
  'box.changed1yStores': 'Zmiana powierzchni w ciągu ostatniego roku',
  'box.changed30dStores': 'Zmiana powierzchni w ciągu ostatnich 30 dni',
  'box.floorSpaceDecreased1yOnly': 'Zmniejszona powierzchnia w ciągu ostatniego roku',
  'box.floorSpaceDecreased30dOnly': 'Zmniejszona powierzchnia w ciągu ostatnich 30 dni',
  'box.floorSpaceIncreased1yOnly': 'Zwiększona powierzchnia w ciągu ostatniego roku',
  'box.floorSpaceIncreased30dOnly': 'Zwiększona powierzchnia w ciągu ostatnich 30 dni',
  'box.new': 'Nowe',
  'box.newStores': 'Sklepy otwarte do pół roku',
  'box.newWebsites': 'Witryny otwarte do pół roku',
  'box.opened1yStores': 'Otwarte w ostatnim roku',
  'box.stationary': 'Stacjonarne',
  'box.website': 'Witryny',
}

const currency = {
  numberLocale: 'pl',
  thousands: 'K {{currency}}',
  millions: 'M {{currency}}',
}

const errorPages = {
  'error.auth': 'Nieprawidłowy login lub hasło',
  'error.hint': 'Spróbuj przeładowac aplikację',
  'error.maintenance': 'Trwa przerwa techniczna',
  'error.message': 'Coś poszło nie tak',
  'error.ok': 'OK',
  'error.reload': 'Przeładuj',
  'error.till': 'do',
  'noAccess.help': 'Pomoc',
  'noAccess.hint': ' Jeżeli posiadasz aktywne konto i nie możesz się zalogować, skontaktuj się z Help Desk.',
  'noAccess.message': 'Nie mogliśmy rozpoznać twoich uprawień do korzystania z aplikacji',
}

const auth = {
  'auth.login': 'Login',
  'auth.password': 'Hasło',
  'auth.submit': 'Zaloguj się',
  'auth.email': 'Email',
}

const search = {
  'search.title': 'Wyszukaj sklep',
  'search.results': 'Wyniki wyszukiwania',
  'search.back': 'Wróć do wyszukiwania',
  'search.backToResults': 'Wróć do wyników',
  'search.found': 'Wybrano {{count}} {{stores}}',
  'search.shopSingle': 'sklep',
  'search.shopMulti': 'sklepy',
  'search.shopMulti2': 'sklepów',
  'search.clear': 'Wyczyść',
  'search.view': 'Szczegóły',
  'search.empty': 'Brak wyników wyszukiwania',
  'search.emptySearchField': ' Wpisz przynajmniej 3 znaki, żeby zobaczyć wyniki wyszukiwania',
  'search.table.shop': 'Sklep',
  'search.table.revenue': 'Utarg',
  'search.table.concept': 'Konc.',
  'search.table.percent': '%',
  'search.selectedItems': 'Pozostałe sklepy',
}

export default {
  ...alert,
  ...auth,
  ...box,
  ...channelsFloorspaceModal,
  ...channelsTabs,
  ...clubCardModal,
  ...common,
  ...config,
  ...countries,
  ...currency,
  ...date,
  ...errorPages,
  ...menu,
  ...myResults,
  ...rankings,
  ...ReportBugDialog,
  ...returnsValueDetails,
  ...revenue,
  ...search,
  ...tableClubCard,
  ...tableEsize,
  ...tableMargin,
  ...tableOrders,
  ...tableReplenishment,
  ...tableSourceData,
  ...tableTraffic,
  ...tableWeather,
}
